// addressApi.js
import { sendRequest } from '@/common/sendRequest'; // 공통 함수 import

/**
 * 주소 관련 API
 * - POST 방식으로만 호출된다고 가정
 * - "method: 'POST'" + "data" 를 기본 옵션으로 사용
 */
const addressApi = {

  /**
   * (신규) 모든 주소 조회
   */
  async findAllAddresses(data) {
    return sendRequest('/api/authn/mypage/addressinfo/findAllAddresses', {
      method: 'POST',
      data,
    });
  },

  /**
   * 특정 사용자 주소 목록 조회
   */
  async findUserAddress(data) {
    return sendRequest('/api/authn/mypage/addressinfo/findUserAddress', {
      method: 'POST',
      data,
    });
  },

  /**
   * 특정 주소(또는 대표 주소) 조회
   */
  async findAddressById(data) {
    return sendRequest('/api/authn/mypage/addressinfo/findAddressById', {
      method: 'POST',
      data,
    });
  },

  /**
   * 주소 추가
   */
  async createUserAddress(data) {
    return sendRequest('/api/authn/mypage/addressinfo/createUserAddress', {
      method: 'POST',
      data,
    });
  },

  /**
   * 주소 수정
   */
  async updateAddress(data) {
    return sendRequest('/api/authn/mypage/addressinfo/updateAddress', {
      method: 'POST',
      data,
    });
  },

  /**
   * 주소 삭제
   */
  async deleteAddress(data) {
    return sendRequest('/api/authn/mypage/addressinfo/deleteAddress', {
      method: 'POST',
      data,
    });
  },

  /**
   * 배송 주소 설정
   */
  async updateDefaultShipping(data) {
    return sendRequest('/api/authn/mypage/addressinfo/updatedelivery', {
      method: 'POST',
      data,
    });
  },

  /**
   * 청구지 주소 설정
   */
  async updateDefaultBilling(data) {
    return sendRequest('/api/authn/mypage/addressinfo/updatebilling', {
      method: 'POST',
      data,
    });
  },
};

export default addressApi;
